import ForecastCard from "./ForecastCard.jsx";

/** A card in Recent. */
export function RecentRow(props) {
  return <ForecastCard {...props} watched={false} />;
}
